import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import { MappedFileTypes } from '../constants'

export type CollabFile = CollabFileGoogle | CollabFileMS

export type CollabFileGoogle = {
  fileUrl: string
  fileName: string
  fileType: (typeof MappedFileTypes)[keyof typeof MappedFileTypes]
}

export type CollabFileMS = {
  fileName: string
  fileType: (typeof MappedFileTypes)[keyof typeof MappedFileTypes]
  fileId: string
  driveId: string
  fileUrl: string
  resourceUrl: string
  siteUrl: string
}

type InitialState = CollabFile | object

const initialState: InitialState = {}

const fileSlice = createSlice({
  name: 'collabFile',
  initialState,
  reducers: {
    setCollabFile: (
      _state: InitialState,
      { payload }: PayloadAction<CollabFile>
    ) => {
      return payload
    },
    clearCollabFile: () => {
      return {}
    },
  },
})

export const { setCollabFile, clearCollabFile } = fileSlice.actions

export const selectCollabFile = (state: RootState) => state.collabFile

export default fileSlice
